import { IPaginationFilter } from '../../../../app.common/modules/common/models';
import { StoreJispPay, StoreJispPayListItem, SalesAssistantListItem, StoreForShopingListItem } from '../../core';

export interface IPaginationjisppayStaffFilter extends IPaginationFilter {
    placeID: number | string;
    keyword: string;
    isActive: boolean | string;
}

export interface IStoreJispPay extends StoreJispPay {
    isPasswordExist: boolean;
    selectedMerchant: any;
}

export interface IStoreJispPayListItem extends StoreJispPayListItem {
    merchantID: string;
    isOpenEdit: boolean;
    refundPassword?: string;
}

export interface ISalesAssistantPlace {
    id: number;
    info: string;
    isActive: boolean;
    isBanned: boolean;
}

export interface ISalesAssistantListItem extends SalesAssistantListItem {
    isContainsBanned: boolean;
    places: ISalesAssistantPlace[];
    selected: boolean;
    avatarUrl?: string;
}

export interface IStoreForShopingListItem extends StoreForShopingListItem {
    info: string;
}

export enum AccountTypeEnum {
    staff = 1,
    vendor = 2,
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/jispPay/models/index.ts